
export default function CircleLoader(){
    return(
        <span className="loader"></span>
    )
}